
import React, { createContext, useState, useContext } from 'react';

const PrivacyContext = createContext();

export const PrivacyProvider = ({ children }) => {
    // Padrão visível (false), mas lê do localStorage se existir
    const [isPrivate, setIsPrivate] = useState(() => {
        const saved = localStorage.getItem('privacy_mode');
        return saved === 'true'; // Se 'true' string, retorna true. Se null ou 'false', retorna false (visível)
    });

    const togglePrivacy = () => {
        setIsPrivate(prev => {
            const newValue = !prev;
            localStorage.setItem('privacy_mode', newValue);
            return newValue;
        });
    };

    return (
        <PrivacyContext.Provider value={{ isPrivate, togglePrivacy }}>
            {children}
        </PrivacyContext.Provider>
    );
};

export const usePrivacy = () => useContext(PrivacyContext);
